<script lang="ts">
import { defineComponent } from 'vue';

import type { NTable } from './interface';

export type TColumnProps<RecordType = NTable.TDefaultRecord> = NTable.NColumn.IColumn<RecordType>;

/**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */
export default defineComponent<TColumnProps>({
  name: 'CdsTableColumn',
  slots: ['title', 'filterIcon', 'default'],
  render() {
    return null;
  }
});
</script>
